import type { ChatResponseEvent } from '@ai-chat-widget-contracts/contracts'
import type { AiChatWebSocketEventData } from '@/modules/webSocket/types'

export const toAiChatResponseEvent = (
  data: AiChatWebSocketEventData['data'] | undefined,
  activeTenantUserId: string | undefined,
  sequence: number,
): ChatResponseEvent | null => {
  const { jobId, conversationId, messageId, status, tenantUserId, errorCode, errorDetails } = data || {}
  if (!conversationId || !activeTenantUserId || tenantUserId !== activeTenantUserId) return null
  if (status === 'completed' && !messageId) return null
  if (status === 'failed' && !jobId) return null
  if (status !== 'completed' && status !== 'failed') return null
  return { sequence, jobId, conversationId, messageId, status, errorCode, errorDetails }
}
